import "./SkillCard.css"

const SkillCard = ({ icon, title, description }) => {
  return (
    <div className="skill-card">
      <div className="skill-icon">
        <i className={icon}></i>
      </div>
      <h3>{title}</h3>
      <p>{description}</p>
    </div>
  )
}

export default SkillCard

